/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaGroupCreate = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        leagueId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        fantaTeamId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
